import script from "./CommonDownloadButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonDownloadButton.vue?vue&type=script&lang=ts&setup=true"

import "./CommonDownloadButton.vue?vue&type=style&index=0&id=124ce606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124ce606"]])

export default __exports__